import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-order-confirmation-status',
  templateUrl: './order-confirmation-status.component.html',
  styleUrls: ['./order-confirmation-status.component.css']
})
export class OrderConfirmationStatusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }

  // social share
  public pageURL;

  openShareLink(): void {
    $('.sharelink').slideToggle();
  }

}
